module.exports = __webpack_public_path__ + "static/sevenhugs-thumb-gif3-eb8c53fb5e65407294b3e0107e16ed59.gif";